import { growHeightFadeIn } from '@/utils/animations';
import { DS_BREAKPOINT } from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';
import { responsivePaddingDefault } from '@rhg/libs/material/sx';

export const styleDialogBackgroundImage = {
    backgroundColor: 'background.primary',
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    height: '100%',
    width: '100%',
};

export const styleDialogBackground = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? theme.palette.mask.white['80p']
            : theme.palette.mask.black['60p'],
};

export const styleTransparentDialogBackground = {
    backgroundColor: 'transparent',
};

export const stylePlayerContainer = {
    position: 'relative',
    width: '100%',
    height: '100%',
    p: responsivePaddingDefault,
};

export const styleContent = { maxWidth: DS_BREAKPOINT.LARGE };

export const styleClickableBackgroundRegion = {
    height: '100%',
    position: 'unset',
    top: 'unset',
    zIndex: 2,
};

// Top padding ladder driven by useCompactAudioDialogLayout. The hook
// gates `shouldReduceTopPadding` at <=600px tall (or <=688px when a
// bottom action is mounted); viewports above that keep the full padding.
// See the rationale comment in the hook.
export const styleAudioContainer = (
    hasSubtitles: boolean,
    shouldReduceTopPadding = false
) => ({
    pt: shouldReduceTopPadding ? 16 : hasSubtitles ? 30 : 36,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateRows: '1fr minmax(auto, 100dvh) 1fr',
    justifyItems: 'center',
});

export const styleBottomContainer = {
    width: '100%',
    px: (theme: Theme) => ({
        sm: theme.ds.spacingUnits.SIDE_SMALL,
        md: theme.ds.spacingUnits.SIDE_MEDIUM,
        lg: theme.ds.spacingUnits.SIDE_LARGE,
    }),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
};

export const styleAudioPlayer = {
    width: '100%',
};

export const styleHeightChange = {
    height: '0%',
    opacity: 0,
    animation: `0.3s ease-in-out forwards ${growHeightFadeIn} `,
};

export const styleDialogBottomActionContainer = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '48px',
};
